import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { BRAND_HOME_PAGE, PRODUCTS_DETAIL_PAGE } from "@/settings/constant";
import { Icon, Typography } from "@bookips/sds";
import { Close, Content, Overlay, Portal, Root, Title } from "@radix-ui/react-dialog";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import BrandCard from "../BrandCard";
const tabLabels = [
    "본문분석",
    "워크북",
    "변형문제",
    "직보/파이널"
];
const BrandSamplePreviewDialog = (param)=>{
    let { open , onOpenChange , brand , previewData , isLoading , onCouponClick , homeId , className  } = param;
    const [selectedProductId, setSelectedProductId] = useState("");
    const router = useRouter();
    var _previewData_items;
    // 탭 목록 (상품 목록)
    const tabs = (_previewData_items = previewData === null || previewData === void 0 ? void 0 : previewData.items) !== null && _previewData_items !== void 0 ? _previewData_items : [];
    var _tabs_find;
    // 선택된 상품
    const selectedProduct = (_tabs_find = tabs.find((item)=>item.productId === selectedProductId)) !== null && _tabs_find !== void 0 ? _tabs_find : tabs[0];
    const handleSampleClick = (brandName)=>{
        if (!brandName) return;
        var _previewData_authorName;
        // MX-379: 브랜드 CTA 버튼 클릭 트래킹
        mixpanelEvent("Brand Preview Button Clicked", {
            "Button Type": "브랜드 CTA 버튼",
            "Preview ID": brand === null || brand === void 0 ? void 0 : brand.brandPreviewId,
            "Author Name": (_previewData_authorName = previewData === null || previewData === void 0 ? void 0 : previewData.authorName) !== null && _previewData_authorName !== void 0 ? _previewData_authorName : brand === null || brand === void 0 ? void 0 : brand.authorName,
            "Tab Name": selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productTitle,
            "Product Id": selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productId,
            "Product Title": selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productTitle,
            "Button Name": "전체 자료 보기",
            "Button URL": BRAND_HOME_PAGE(brandName)
        });
        router.push(BRAND_HOME_PAGE(brandName));
        onOpenChange(false);
    };
    // MX-375: 다이얼로그 열릴 때 Viewed 트래킹
    useEffect(()=>{
        if (open && tabs.length > 0 && !selectedProductId) {
            var _tabs_, _tabs_1, _tabs_2;
            setSelectedProductId(tabs[0].productId);
            var _previewData_authorName;
            mixpanelEvent("Brand Preview Dialogue Viewed", {
                "Preview ID": brand === null || brand === void 0 ? void 0 : brand.brandPreviewId,
                "Home Id": homeId,
                "Author Name": (_previewData_authorName = previewData === null || previewData === void 0 ? void 0 : previewData.authorName) !== null && _previewData_authorName !== void 0 ? _previewData_authorName : brand === null || brand === void 0 ? void 0 : brand.authorName,
                "Tab Name": (_tabs_ = tabs[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.productTitle,
                "Product Id": (_tabs_1 = tabs[0]) === null || _tabs_1 === void 0 ? void 0 : _tabs_1.productId,
                "Product Title": (_tabs_2 = tabs[0]) === null || _tabs_2 === void 0 ? void 0 : _tabs_2.productTitle
            });
        }
    }, [
        open,
        tabs,
        selectedProductId
    ]);
    // 다이얼로그가 닫힐 때 상태 초기화
    useEffect(()=>{
        if (!open) {
            setSelectedProductId("");
        }
    }, [
        open
    ]);
    if (!brand) return null;
    var _previewData_authorName;
    return /*#__PURE__*/ _jsx(Root, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(Portal, {
            children: [
                /*#__PURE__*/ _jsx(Overlay, {
                    className: "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-overlay bg-gray-900/50"
                }),
                /*#__PURE__*/ _jsx(Content, {
                    onClick: (e)=>{
                        // Content 배경 클릭 시 닫기 (자식 요소 클릭은 제외)
                        if (e.target === e.currentTarget) {
                            onOpenChange(false);
                        }
                    },
                    className: cn("fixed inset-0 z-dialog flex items-start justify-center pt-12 pb-0 max-lg:pt-6", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "pointer-events-none relative mx-6 flex h-full max-w-[1200px] flex-1 flex-col gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                asChild: true,
                                children: /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "h4",
                                    className: "shrink-0 text-white",
                                    children: [
                                        (_previewData_authorName = previewData === null || previewData === void 0 ? void 0 : previewData.authorName) !== null && _previewData_authorName !== void 0 ? _previewData_authorName : brand.badgeText,
                                        " 유형별 자료 샘플"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex min-h-0 flex-1 gap-[72px] max-lg:gap-8",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "pointer-events-auto flex min-w-0 flex-1 flex-col gap-3 overflow-y-auto",
                                        children: [
                                            isLoading && /*#__PURE__*/ _jsx("div", {
                                                className: "flex flex-1 items-center justify-center",
                                                children: /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "body1",
                                                    className: "text-white",
                                                    children: "로딩 중..."
                                                })
                                            }),
                                            tabs.length > 0 && /*#__PURE__*/ _jsx("div", {
                                                className: "flex shrink-0 gap-0.5 rounded-md bg-gray-100 p-0.5",
                                                children: tabs.map((tab, index)=>{
                                                    var _tabLabels_index;
                                                    return /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            var _previewData_authorName, _tabLabels_index;
                                                            // MX-377: 탭 클릭 트래킹
                                                            mixpanelEvent("Brand Preview Button Clicked", {
                                                                "Button Type": "탭",
                                                                "Preview ID": brand === null || brand === void 0 ? void 0 : brand.brandPreviewId,
                                                                "Author Name": (_previewData_authorName = previewData === null || previewData === void 0 ? void 0 : previewData.authorName) !== null && _previewData_authorName !== void 0 ? _previewData_authorName : brand === null || brand === void 0 ? void 0 : brand.authorName,
                                                                "Tab Name": (_tabLabels_index = tabLabels[index]) !== null && _tabLabels_index !== void 0 ? _tabLabels_index : tab.productTitle,
                                                                "Product Id": tab.productId
                                                            });
                                                            setSelectedProductId(tab.productId);
                                                        },
                                                        className: cn("flex-1 rounded px-3 py-2 transition-colors", selectedProductId === tab.productId ? "bg-white shadow-sm" : "text-secondary hover:text-primary"),
                                                        children: /*#__PURE__*/ _jsx(Typography, {
                                                            variant: "subtitle1",
                                                            className: cn("line-clamp-1", selectedProductId === tab.productId ? "text-strong" : "text-secondary"),
                                                            children: (_tabLabels_index = tabLabels[index]) !== null && _tabLabels_index !== void 0 ? _tabLabels_index : tab.productTitle
                                                        })
                                                    }, tab.productId);
                                                })
                                            }),
                                            !isLoading && selectedProduct && /*#__PURE__*/ _jsxs(Link, {
                                                href: "".concat(PRODUCTS_DETAIL_PAGE, "/").concat(selectedProduct.productId),
                                                onClick: ()=>{
                                                    var _previewData_authorName, _tabLabels_tabs_findIndex;
                                                    // MX-384: 샘플 자료 자세히보기 클릭 트래킹
                                                    mixpanelEvent("Brand Preview Button Clicked", {
                                                        "Button Type": "샘플 자료 자세히보기",
                                                        "Preview ID": brand === null || brand === void 0 ? void 0 : brand.brandPreviewId,
                                                        "Home Id": homeId,
                                                        "Author Name": (_previewData_authorName = previewData === null || previewData === void 0 ? void 0 : previewData.authorName) !== null && _previewData_authorName !== void 0 ? _previewData_authorName : brand === null || brand === void 0 ? void 0 : brand.authorName,
                                                        "Tab Name": (_tabLabels_tabs_findIndex = tabLabels[tabs.findIndex((t)=>t.productId === selectedProductId)]) !== null && _tabLabels_tabs_findIndex !== void 0 ? _tabLabels_tabs_findIndex : selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productTitle,
                                                        "Product Id": selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productId
                                                    });
                                                },
                                                className: "flex w-full items-center justify-between rounded-md bg-white p-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex flex-1 items-center gap-3",
                                                        children: [
                                                            selectedProduct.thumbnailUrl && /*#__PURE__*/ _jsx("div", {
                                                                className: "relative h-12 w-[34px] shrink-0 overflow-hidden rounded",
                                                                children: /*#__PURE__*/ _jsx(Image, {
                                                                    src: selectedProduct.thumbnailUrl,
                                                                    alt: "",
                                                                    fill: true,
                                                                    className: "object-cover"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex flex-col items-start",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Typography, {
                                                                        variant: "subtitle1",
                                                                        className: "text-primary",
                                                                        children: "샘플 자료 자세히보기"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Typography, {
                                                                        variant: "body2",
                                                                        className: "text-secondary",
                                                                        children: selectedProduct.productTitle
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {
                                                        className: "text-muted size-6"
                                                    })
                                                ]
                                            }),
                                            !isLoading && (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.previews.map((preview)=>/*#__PURE__*/ _jsx("div", {
                                                    className: "relative aspect-[788/1115] w-full shrink-0 overflow-hidden rounded-md bg-white",
                                                    children: /*#__PURE__*/ _jsx(Image, {
                                                        src: preview.url,
                                                        alt: "",
                                                        fill: true,
                                                        className: "object-cover"
                                                    })
                                                }, "".concat(selectedProduct.productId, "-").concat(preview.pageNum))))
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "pointer-events-auto h-fit w-full max-w-[340px] min-w-[300px] shrink-0 pt-[72px]",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "overflow-hidden rounded-lg bg-white",
                                            children: /*#__PURE__*/ _jsx(BrandCard, {
                                                ...brand,
                                                sampleButton: {
                                                    show: !!brand.brandName,
                                                    label: "전체 자료 보기",
                                                    onClick: ()=>handleSampleClick(brand.brandName)
                                                },
                                                onCouponClick: onCouponClick,
                                                className: "w-full",
                                                imageClassName: "h-auto aspect-[340/239]",
                                                imageRounded: false,
                                                infoClassName: "p-5"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Close, {
                                asChild: true,
                                children: /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        // MX-380: 닫기 버튼 클릭 트래킹
                                        mixpanelEvent("Close Button", {
                                            Position: "Brand Preview Dialogue"
                                        });
                                    },
                                    className: "pointer-events-auto absolute top-0 right-0 flex size-12 items-center justify-center rounded-md border border-gray-200 bg-white transition-colors hover:bg-gray-50",
                                    children: /*#__PURE__*/ _jsx(Icon.Close_2px, {
                                        className: "size-6"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export default BrandSamplePreviewDialog;
